import { Box, Tooltip } from "@mui/material";
import React from "react";
import CoverArticleImage from "@/src/_types/Article/cover-image";
import CoverPlate from "@/src/components/common/broadsheet/cover-plate";
import { stripHTMLTags } from "@/src/utils/strip-html-tags";

const ArticleCoverImage: React.FC<CoverArticleImage> = ({
  src,
  caption,
  spine,
}) => (
  <Tooltip title={stripHTMLTags(caption)}>
    <Box className={"cover_image"} sx={{ pr: "5px", pb: "6px" }}>
      <CoverPlate
        src={src}
        alt={stripHTMLTags(caption)}
        width={144}
        height={144}
        offset={5}
        framed
        spine={spine ?? "var(--bf-spine-teal)"}
      />
    </Box>
  </Tooltip>
);

export default ArticleCoverImage;
